import styled from 'styled-components'

export const LinkSeparator = styled.div`
  border-right: 1px solid ${props => props.theme.colors.greyscale.light};
  height: 100%;
`

const Accessible = `
  position: absolute !important;
  height: 1px; width: 1px;
  overflow: hidden;
  padding: 0;
  border: 0;
  clip: rect(1px 1px 1px 1px);
  clip: rect(1px, 1px, 1px, 1px);
`

export const H4 = styled.div`
  font-size: ${props => props.theme.typography.fontSize.fs4};
  line-height: ${props => props.theme.typography.fontSize.lh5};
  font-weight: 700;
  margin: 0 0 15px 0;
`

export const H5 = styled.div`
  font-size: ${props => props.theme.typography.fontSize.fs3};
  line-height: ${props => props.theme.typography.fontSize.lh4};
  font-weight: 700;
  margin: 0 0 15px 0;
`

export const AccessibleText = styled.div`${Accessible}`
export const AccessibleLabel = styled.label`${Accessible}`
